import {Component, Input} from '@angular/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';

// NOTE: To have this positioned over the content, the containing element should have relative positioning.
// Wrap the element around any custom content, e.g. <app-loading-overlay><p>{{loadedPercent}}% loaded</p><app-loading-overlay>
@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() progress: number;
}
